export function localizeHref(href: string, currentLang: string): string {
  if (currentLang === "en" && href.startsWith("/") && !href.startsWith("//")) {
    // Root "/" must map to "/en", not "/en/" — a trailing slash makes
    // +page.ts fetch "/en/.json" (404). Mirror alternateUrls() in seo/site.ts.
    return href === "/" ? "/en" : "/en" + href.replace(/\/+$/, "");
  }
  return href;
}
